import * as React from "react";

export const Export = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.57564 2.57576C7.80995 2.34145 8.18985 2.34145 8.42417 2.57576L11.4242 5.57576C11.6585 5.81008 11.6585 6.18997 11.4242 6.42429C11.1899 6.6586 10.81 6.6586 10.5756 6.42429L8.5999 4.44855V10.5C8.5999 10.8314 8.33127 11.1 7.9999 11.1C7.66853 11.1 7.3999 10.8314 7.3999 10.5V4.44855L5.42417 6.42429C5.18985 6.6586 4.80995 6.6586 4.57564 6.42429C4.34132 6.18997 4.34132 5.81008 4.57564 5.57576L7.57564 2.57576ZM2.3999 13C2.3999 12.6687 2.66853 12.4 2.9999 12.4H12.9999C13.3313 12.4 13.5999 12.6687 13.5999 13C13.5999 13.3314 13.3313 13.6 12.9999 13.6H2.9999C2.66853 13.6 2.3999 13.3314 2.3999 13Z"
    />
);
